<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FM-head2" id="Int">Introduction</h1>
<p class="noindent">This book is your must-have guide to macraweaving, the exciting new craft that brings together two timelessly popular fibre arts, macramé and weaving. By combining the essential knots of macramé with three of the most fundamental weaving techniques, you will discover how simple it can be to work with texture and colour to make beautiful, eye-catching pieces for your home.</p>
<p class="noindent1">Whether you are looking to learn a fresh skill, or to take your macramé to a whole new level, you’ll find everything you need right here. We’ve put together an enticing selection of eighteen projects for you to choose from to satisfy all your creative ambitions, whether you are searching for functionality or for an artistic feature to transform a room.</p>
<p class="noindent1">Every project, be it our simple starter Keeper Key Rings to our phenomenal Pride and Joy Wall Hanging, is explained in clear step-by-step detail. We begin with the macramé element for each, as this must be done first to create a structure of negative spaces, or warp threads, through which the weft threads are woven in the weaving element.</p>
<p class="noindent">In devising our designs, we have aimed to introduce you to a wide variety of decorative possibilities, using an assortment of rope in different fibres and thicknesses, exploring rich colourways and interesting textural techniques.</p>
<p class="noindent1">You’ll find more information on the materials we have used in the Techniques section, along with essential illustrated reference on the knots and the weaves, as well as a comprehensive guide to understanding the macraweave technique, which we suggest you practise in full before beginning your first project. Each project chapter lists the materials you will need and the techniques required, so you can review the tying and weaving sequences as you go; follow these precisely and you will find that even the most complex of designs is easier to achieve than you may have expected.</p>
<p class="image-center"><img alt="" src="images/P5-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?5ead853c